// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { useStore } from '@/store';

export const useScreenshotService = () => {
    // hooks
    const axios = useAxios();
    const store = useStore();

    // data
    const tempImageUrl = 'https://docs.mapbox.com/mapbox-gl-js/assets/cat.png';

    // methods
    const generateQueryParams = (options: any): string => {
        let queryParams = '';
        Object.keys(options).forEach((key: string, i: number) => {
            queryParams += `${key}=${options[key]}`;
            if (Object.keys(options).length !== i - 1) {
                queryParams += '&';
            }
        });
        return queryParams;
    };

    const generateScreenshotUrl = (
        width: number,
        height: number,
        bounds: number[],
        azimuth: number,
        style: any,
    ) => {
        const url = `${store.state.apiUrl}/screenshot`;
        const options = {
            width: width,
            height: height,
            padding: 0,
            token: 'pk.eyJ1IjoiY2xlcmVnb2xmIiwiYSI6ImNsMDA0bXF3ZTA4enEzaW1lbm82bTg1NDUifQ.SUL023sSnXEUXAiUgQ8iGA',
            bounds: `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`,
            bearing: azimuth * (180 / Math.PI),
            style: encodeURIComponent(JSON.stringify(style)),
        };

        return `${url}/render?${generateQueryParams(options)}`;
    };

    const courseScreenshot = async (
        width: number,
        height: number,
        bounds: number[],
        azimuth: number,
        style: any,
        iconArray: any,
    ) => {
        const iconArrayObject = iconArray.reduce((acc, cur) => {
            acc[cur.name] = cur;
            return acc;
        }, {});

        const url = `${store.state.apiUrl}/screenshot`;
        const res = await axios.post(
            url,
            {
                width: width,
                height: height,
                padding: 0,
                token: 'pk.eyJ1IjoiY2xlcmVnb2xmIiwiYSI6ImNsMDA0bXF3ZTA4enEzaW1lbm82bTg1NDUifQ.SUL023sSnXEUXAiUgQ8iGA',
                bounds: `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`,
                bearing: azimuth * (180 / Math.PI),
                style: style,
                images: iconArrayObject,
                ratio: 2,
            },
            undefined,
            { responseType: 'blob' },
        );
        return res.data;
    };

    const screenshot = async (
        width: number,
        height: number,
        bounds: number[],
        azimuth: number,
        style: any,
        currentPinIcon: any,
        pixelRatio: number,
    ) => {
        const image = {
            iconImage: {
                url: currentPinIcon.id ? currentPinIcon.path : tempImageUrl,
                sdf: false,
                pixelRatio: pixelRatio,
            },
        };

        const url = `${store.state.apiUrl}/screenshot`;
        const res = await axios.post(
            url,
            {
                width: width,
                height: height,
                padding: 0,
                token: 'pk.eyJ1IjoiY2xlcmVnb2xmIiwiYSI6ImNsMDA0bXF3ZTA4enEzaW1lbm82bTg1NDUifQ.SUL023sSnXEUXAiUgQ8iGA',
                bounds: `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`,
                bearing: azimuth * (180 / Math.PI),
                style: style,
                images: image,
                ratio: pixelRatio,
            },
            undefined,
            { responseType: 'blob' },
        );
        return res.data;
    };

    return {
        generateScreenshotUrl,
        screenshot,
        courseScreenshot,
    };
};
